import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhandardaracab() {



  const cardData = {
"keyword": "Pune to Bhandardara Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Bhandardara Cab service for travelers seeking safe, scenic, and affordable nature and hill station travel. Whether you are planning a weekend getaway, family picnic, monsoon trip, trekking adventure, or photography tour, our taxi service ensures a smooth and stress-free journey to this beautiful lakeside destination. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Bhandardara. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and memorable travel experience.",

"topPlaces": [
  {
    "title": "Arthur Lake",
    "description":
      "Arthur Lake is a serene lake formed by the Wilson Dam and is the heart of Bhandardara’s natural beauty. Travelers using Pune to Bhandardara cab service often visit this peaceful spot for relaxation and scenic views."
  },
  {
    "title": "Wilson Dam",
    "description":
      "Wilson Dam is one of the oldest dams in India and offers stunning views of overflowing water during monsoon season. Cab travelers from Pune enjoy visiting this iconic structure."
  },
  {
    "title": "Randha Falls",
    "description":
      "Randha Falls is a spectacular waterfall on the Pravara River known for its powerful flow during monsoon. Pune to Bhandardara taxi service provides easy access for nature lovers and photographers."
  },
  {
    "title": "Kalsubai Peak",
    "description":
      "Kalsubai Peak is the highest peak in Maharashtra and a popular trekking destination near Bhandardara. Travelers booking Pune to Bhandardara cabs often include this adventure spot in their itinerary."
  },
  {
    "title": "Umbrella Falls",
    "description":
      "Umbrella Falls is a seasonal waterfall that resembles an umbrella shape during monsoon. Cab from Pune to Bhandardara is ideal for sightseeing during rainy season."
  },
  {
    "title": "Amruteshwar Temple",
    "description":
      "Amruteshwar Temple is an ancient Shiva temple known for its Hemadpanthi architecture and spiritual significance. Travelers from Pune often visit this heritage site."
  },
  {
    "title": "Ghatghar Viewpoint",
    "description":
      "Ghatghar Viewpoint offers breathtaking views of valleys, hills, and the Konkan region. Pune to Bhandardara cab service makes it easy to reach this scenic location."
  },
  {
    "title": "Samrad Village",
    "description":
      "Samrad Village is a base point for the famous Sandhan Valley trek known as the Valley of Shadows. Cab travelers from Pune often start their adventure from here."
  },
  {
    "title": "Ratangad Fort",
    "description":
      "Ratangad Fort is a historic hill fort offering panoramic views of the Sahyadri mountains. Pune to Bhandardara taxi service is ideal for trekking and heritage exploration."
  },
  {
    "title": "Bhandardara Camping Sites",
    "description":
      "Bhandardara is famous for lakeside camping experiences under the stars. Travelers from Pune often book cab services for weekend camping and outdoor activities."
  }
],



services: [
  {
    name: "Pune to Bhandardara Cab",
    description: "Pune to Bhandardara cab service provides reliable transportation between Pune and Bhandardara with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and hill station travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Bhandardara Taxi",
    description: "Pune to Bhandardara taxi service offers dependable transportation for passengers traveling between Pune and Bhandardara with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for tourism, dam visits, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Bhandardara",
    description: "Cab from Pune to Bhandardara service provides comfortable intercity transportation for passengers traveling for tourism, weekend trips, and family vacations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Bhandardara. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Bhandardara",
    description: "Taxi from Pune to Bhandardara service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Bhandardara. Vehicles provide smooth highway and hill route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Bhandardara Cab Service",
    description: "Pune to Bhandardara cab service provides dependable transportation solutions for passengers traveling between Pune and Bhandardara with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for hill station and dam-side travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Ideal for tourism, sightseeing, and weekend trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Bhandardara Taxi Fare",
    description: "Pune to Bhandardara taxi fare service provides transparent pricing information for passengers planning travel between Pune and Bhandardara. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Bhandardara One Way Cab",
    description: "Pune to Bhandardara one way cab service provides economical transportation for passengers traveling from Pune to Bhandardara without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for tourism, weekend getaways, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Bhandardara including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Bhandardara Round Trip Taxi",
    description: "Pune to Bhandardara round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Bhandardara. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Ideal for tourism, sightseeing, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Bhandardara Cab Booking",
    description: "Pune to Bhandardara cab booking service allows passengers to reserve comfortable transportation between Pune and Bhandardara. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Bhandardara Cab",
    description: "Cheap Pune to Bhandardara cab service provides affordable transportation between Pune and Bhandardara with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, weekend travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Bhandardara. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Bhandardara Taxi",
    description: "Best Pune to Bhandardara taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth hill station travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Bhandardara Cab",
    description: "Sedan Pune to Bhandardara cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Bhandardara. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for hill station journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Bhandardara. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Bhandardara Taxi",
    description: "SUV Pune to Bhandardara taxi service provides spacious transportation for families and groups traveling between Pune and Bhandardara. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for hill station journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhandardara. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Bhandardara Cab",
    description: "Innova Pune to Bhandardara cab service provides premium SUV transportation for passengers seeking comfortable and reliable hill station travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Bhandardara. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Dam Trip Cab Pune Bhandardara",
    description: "Dam trip cab Pune Bhandardara service offers dependable transportation for passengers traveling from Pune to the scenic Bhandardara dam region. Comfortable vehicles ensure smooth highway and ghat section travel suitable for tourism, monsoon trips, camping, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Bhandardara. Flexible booking options allow convenient dam trip cab reservations."
  }
],

tableData: [
  ["Pune to Bhandardara Cab", "Pune to Bhandardara Taxi"],
  ["Cab from Pune to Bhandardara", "Taxi from Pune to Bhandardara"],
  ["Pune to Bhandardara Cab Service", "Pune to Bhandardara Taxi Fare"],
  ["Pune to Bhandardara One Way Cab", "Pune to Bhandardara Round Trip Taxi"],
  ["Pune to Bhandardara Cab Booking", "Cheap Pune to Bhandardara Cab"],
  ["Best Pune to Bhandardara Taxi", "Sedan Pune to Bhandardara Cab"],
  ["SUV Pune to Bhandardara Taxi", "Innova Pune to Bhandardara Cab"],
  ["Dam Trip Cab Pune Bhandardara", "Pune to Bhandardara Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Bhandardara Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Bhandardara cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe hill station travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Bhandardara Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Bhandardara cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Bhandardara Cab Availability",
        WhyChoosedescription: "Our Pune to Bhandardara cab service operates 24 hours a day for family vacations, camping trips, nature tours, weekend getaways, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for passengers visiting Bhandardara."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Bhandardara taxi service, round-trip bookings, sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ghat Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Bhandardara highway and ghat routes, ensuring safe driving, smooth travel, and timely arrival for every hill station journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Bhandardara cab service?", answer: "Pune to Bhandardara cab service provides comfortable taxi transportation between Pune and Bhandardara for sightseeing, camping trips, and weekend travel." },
    { question: "Is Pune to Bhandardara cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Bhandardara cab service." },
    { question: "Which vehicles are available for Pune to Bhandardara travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Bhandardara?", answer: "Yes, customers can book one-way as well as round-trip Pune to Bhandardara taxi services." },
    { question: "Do you provide sightseeing cab service in Bhandardara?", answer: "Yes, Shivai Travels provides sightseeing taxi packages for Bhandardara, Arthur Lake, Randha Falls, and nearby tourist attractions." },
    { question: "Are all Pune to Bhandardara taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Bhandardara cab service online?", answer: "Yes, customers can easily book Pune to Bhandardara cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Bhandardara cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Bhandardara cab service?", answer: "Yes, advance booking is available and recommended during weekends, monsoon seasons, and holidays." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akash Patwardhan",
      feedback:
        "Booked Pune to Bhandardara cab service with Shivai Travels. Comfortable vehicle, smooth ghat travel, and very professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Pune to Bhandardara taxi service. Affordable pricing, clean cab, and wonderful nature trip experience.",
      rating: 5
    }
  ];




























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhandardara Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-bhandardara-cab.jpg",
  "description": "Book Pune to Bhandardara cab service for safe and comfortable lake and dam trip travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for weekend and nature trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-bhandardara-cab"
  }
};









  return (
    <div>

<Helmet>
  <title>Pune to Bhandardara Cab Service | Dam & Nature Trip Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Bhandardara cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for dam visit, lake view, and nature trips."
  />

  <meta
    name="keywords"
    content="pune to bhandardara cab, pune to bhandardara taxi, cab from pune to bhandardara, taxi from pune to bhandardara, pune to bhandardara cab service, pune to bhandardara taxi fare, pune to bhandardara one way cab, pune to bhandardara round trip taxi, pune to bhandardara cab booking, cheap pune to bhandardara cab, best pune to bhandardara taxi, sedan pune to bhandardara cab, suv pune to bhandardara taxi, innova pune to bhandardara cab, dam trip cab pune bhandardara"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhandardaracab;